import Vue from 'vue';
import { Component } from 'vue-property-decorator' ;
import { namespace } from 'vuex-class';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SET_DOCUMENT_PARAMETER, DOCUMENT_LOADERS } from '../../../store/document';
import { IDocumentTypeListingViewmodel, IDocumentParamter } from '../../../models/documents';
import { Uris } from '../../../common/constants';
import * as moment from 'moment' ;

const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

@Component({
    components: {
        'document-categories-loader': async () => import ('../loaders/document-categories-loader/DocumentCategoriesLoader.vue')
    }
})
class DocumentCategoriesList extends Vue {
    readonly LOADING_CATEGORIES: {}[] = Array.from(new Array(3)).map(item=> ({}))
    constructor(){
        super()
    }

    @DocumentStore.Getter documentTypes: IDocumentTypeListingViewmodel[]
    @DocumentStore.Getter loaders: Map<string,boolean>

    @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
    storeSetDocumentParameter: (payload: IDocumentParamter) => void


    get lblSetting() {
        return { ...require('../../../locales/document').default }
    }

    get coTypes(): any[] {
        return [{ header: this.$t(this.lblSetting.documentCategoriesHeader) }].concat(
            this.coLoader ? this.LOADING_CATEGORIES : <any[]>this.documentTypes)
    }

    get coLoader(): boolean {
        return this.loaders.get(DOCUMENT_LOADERS.CATEGORIES_LOADER)
    }

    getDocumentTitle(item: any){
        return `${item.name} (${item.totalDocuments})`
    }

    getDocumentSubTitle(item: any){
        return this.$t(this.lblSetting.documentLastAdded,{ date: moment(item.last_added.date).format("DD/MM/YYYY"), by: item.last_added.creator })
    }

    handleDocumentClick(id: number){
        this.$router.push(Uris.DocumentsId.replace(':id',id.toString()))
    }
}

export default DocumentCategoriesList



// WEBPACK FOOTER //
// ./src/containers/documents/document-categories-list/index.ts